/** @format */

export {
    TRUSTPILOT_TEMPLATE_IDS,
    getCommonTrustpilotConfig,
    trustpilot,
} from './helpers/trustpilot';

export type { TrustpilotConfig } from './config/types';
